export const REFRESH_TABS_LOCAL_STORAGE_KEY = 'refreshTabs';
